import {Link as RouterLink} from 'react-router';
import {Alert, Button, Center, Heading, SimpleGrid, Spinner, Text, VStack} from '@chakra-ui/react';
import {useDrives} from '../drive/queries';
import {parseDriveYear} from '../domain/naming';
import {describeDriveError} from '../drive/driveApi';

export function YearSelectorPage() {
    const drivesQuery = useDrives();

    if (drivesQuery.isPending) {
        return <Center mt={10}><Spinner size="lg"/></Center>;
    }

    if (drivesQuery.isError) {
        return <Center mt={10}>
            <Alert.Root status="error" maxW="md" borderRadius="md">
                <Alert.Indicator/>
                <Alert.Title>{describeDriveError(drivesQuery.error)}</Alert.Title>
            </Alert.Root>
        </Center>;
    }

    const years = drivesQuery.data
        .map((drive) => ({drive, year: parseDriveYear(drive.name)}))
        .filter((entry): entry is { drive: typeof entry.drive; year: number } => entry.year !== null)
        .sort((a, b) => b.year - a.year);

    if (years.length === 0) {
        return <Center mt={10}>
            <VStack gap={2} maxW="md" textAlign="center">
                <Heading size="md">Nem található SPOT megosztott meghajtó</Heading>
                <Text color="gray.500">
                    Úgy tűnik, hogy a Google-fiókod nem fér hozzá egyetlen „SPOT - &lt;év&gt;” megosztott meghajtóhoz sem.
                    Kérd meg az egyik vezetőségi tagot, hogy adjon hozzá!
                </Text>
            </VStack>
        </Center>;
    }

    return <VStack gap={6} mt={4} px={2}>
        <Heading>Válassz évet</Heading>
        <SimpleGrid columns={{base: 2, sm: 3, md: 4}} gap={4}>
            {years.map(({drive, year}) => (
                <Button
                    asChild
                    key={drive.id}
                    variant="outline"
                    w={{base: '120px', md: '160px'}}
                    h={{base: '80px', md: '100px'}}
                    fontSize="xl"
                >
                    <RouterLink to={`/${year}`}>{year}</RouterLink>
                </Button>
            ))}
        </SimpleGrid>
    </VStack>;
}
